import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InterviewDataService } from './services/interview-data.service';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'begin-interview',
    templateUrl: './begin-interview.component.html',
    standalone: false
})

export class BeginInterviewComponent implements OnInit, AfterViewInit {
    private translate = inject(TranslateService);

    instructions: any;
    interview: any;
    questionTotal: any;
    interviewLength: any;

    constructor(private _dataService: InterviewDataService, private _activatedRoute:ActivatedRoute) {
    }

    ngOnInit() {
        this._activatedRoute.params.subscribe((params) => {
            this._dataService.interviewId = params['id'];
            this._dataService.practice = false;
            this._dataService.getInterviewStats().subscribe((resp) => {
                if (resp) {
                    this.questionTotal = resp['questionTotal'];
                    this.interviewLength = resp['interviewLength'];
                }
            });
        });
    }

    ngAfterViewInit() {
        document.title = this.translate.instant('interviews.Instructions');
    }
}
